import React from 'react';
import AdminRatesList from '../../components/Admin/AdminRatesList';

export const AdminRates = () => {
  return <AdminRatesList />;
};

export default AdminRates;
